const items = [
  { tag: "热议", text: "本周编辑部重点征集：带时间线完整的都市情感瓜" },
  { tag: "提示", text: "邮箱投稿时请勿粘贴超大视频，建议先传网盘并附链接" },
  { tag: "更新", text: "企微投稿通道已恢复收料，短线索受理提速" },
  { tag: "提醒", text: "所有投稿请先做隐私打码，再对外提交" },
  { tag: "干货", text: "投稿标题写「时间+人物+事件」，采纳率更高" },
  { tag: "公告", text: "网页在线表单支持一键多图上传" },
];

export default function HotTicker() {
  const loop = [...items, ...items];
  return (
    <div className="flex items-center overflow-hidden border-b border-background-200/70 bg-background-50 py-3">
      <div className="flex shrink-0 items-center gap-2 px-4 md:px-6">
        <span className="flex h-7 items-center gap-1.5 whitespace-nowrap rounded-full bg-primary-500 px-3 text-xs font-semibold text-background-50">
          <i className="ri-fire-fill text-xs" aria-hidden="true"></i>
          编辑台速递
        </span>
      </div>
      <div className="relative flex-1 overflow-hidden">
        <div className="flex w-max animate-marquee items-center gap-8 whitespace-nowrap">
          {loop.map((it, i) => (
            <span key={i} className="flex items-center gap-2 text-sm text-foreground-600">
              <span
                className={`rounded px-1.5 py-0.5 text-xs font-semibold ${
                  it.tag === "热议"
                    ? "bg-accent-100 text-accent-700"
                    : it.tag === "更新"
                    ? "bg-secondary-100 text-secondary-700"
                    : "bg-background-200 text-foreground-700"
                }`}
              >
                {it.tag}
              </span>
              {it.text}
            </span>
          ))}
        </div>
      </div>
    </div>
  );
}